export enum DeviceTypeEnum {
    HAND_HELD = 'Hand Held',
    SYSTEM = 'System',
}